// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"18":"4e56af41","816":"13cf0505"}[chunkId] + ".js";
};